import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/signup',
    name: 'SignUp',
    component: () => import('../components/SignUp.vue'),
    meta: { guest: true }
  },
  {
    path: '/verify',
    name: 'Verify',
    component: () => import('../components/VerifyCode.vue'),
    meta: { guest: true }
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('../components/Home.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/edit-profile',
    name: 'EditProfile',
    component: () => import('../components/EditProfile.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/edit-email',
    name: 'EditEmail',
    component: () => import('../components/EditEmail.vue'),
    meta: { requiresAuth: true }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// Guard global de autenticación
router.beforeEach((to, _from, next) => {
  const token = localStorage.getItem('dq-token')

  if (to.meta.requiresAuth && !token) {
    // Si la ruta requiere auth y no hay token, redirigir a registro
    return next({ name: 'SignUp' })
  }

  if (to.meta.guest && token && to.name !== 'Verify') {
    // Si la ruta es solo para invitados y ya hay token, mandar al home (excepto para Verify)
    return next({ name: 'Home' })
  }

  return next()
})

export default router 